export default function HRFeatureComparison() {
  const features = [
    {
      feature: "Payroll Automation",
      competitor: "Partial",
      payrollOnly: "✓",
      waggex: "✓",
    },
    {
      feature: "PF / ESI / TDS Compliance",
      competitor: "Manual",
      payrollOnly: "✓",
      waggex: "✓",
    },
    {
      feature: "Leave Management",
      competitor: "Add-on",
      payrollOnly: "x",
      waggex: "✓",
    },
    {
      feature: "Attendance Tracking",
      competitor: "Add-on",
      payrollOnly: "x",
      waggex: "✓",
    },
    {
      feature: "Performance Management",
      competitor: "Paid extra",
      payrollOnly: "x",
      waggex: "✓",
    },
    {
      feature: "Employee Self-Service (ESS)",
      competitor: "Paid extra",
      payrollOnly: "x",
      waggex: "✓",
    },
    {
      feature: "HR Analytics & Reports",
      competitor: "No",
      payrollOnly: "x",
      waggex: "✓",
    },
  ];

  return (
    <section className="py-10 px-6 bg-white">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row gap-8">
        {/* Left Text */}
        <div className="lg:w-[40%] space-y-4 p-2">
          <h2 className="service-section-heading text-[22px]">
            More Than Attendance Complete HR Management
          </h2>
          <p className="service-list-item-text py-4">
            Attendance tools track who came in. Payroll tools cut salaries. But
            neither tells you why your best employee resigned, whether your
            leave balance is correctly reflected in this month's payroll, or
            whether you are at risk of a compliance penalty next quarter. Waggex
            HRMS connects all of these functions because HR decisions should be
            driven by data, not held back by disconnected systems.
          </p>
          <p className="service-list-item-text">
            Indian businesses from startups in Bengaluru to manufacturing units
            in Surat are increasingly choosing integrated HRMS software over
            piecemeal tools. The reason is simple: when payroll, attendance,
            leave, and compliance live in the same platform, errors disappear,
            reporting becomes instant, and your HR team finally has time for
            work that actually matters.
          </p>

          <button
            className="mt-4 bg-[#10324F] text-white h-12.5 px-14 rounded-xl text-xl shadow-lg hover:scale-[1.02] transition"
            onClick={() => (window.location.href = "/contact-us")}
          >
            Book Free Demo
          </button>
        </div>

        {/* Right Table */}
        <div className="lg:w-[60%] overflow-x-auto rounded-md">
          <table className="min-w-full border-collapse text-left">
            <thead className=" bg-[#10324F] text-white">
              <tr className="h-12">
                <th className="px-2 py-1.5 text-sm sm:text-base font-medium">
                  FEATURES
                </th>
                <th className="px-2 py-1.5 text-sm sm:text-base font-medium">
                  COMPETITORS
                </th>
                <th className="px-2 py-1.5 text-sm sm:text-base font-medium">
                  HRIS ONLY
                </th>
                <th className="px-2 py-1.5 text-sm sm:text-base font-medium">
                  WAGGEX HRMS
                </th>
              </tr>
            </thead>
            <tbody>
              {features.map((row, idx) => (
                <tr
                  key={idx}
                  className={`
                    ${idx % 2 === 0 ? "bg-white" : "bg-[#f9fbfd]"} 
                    backdrop-blur-[15px] 
                    shadow-[-10px_-10px_20px_0_#D1DFEA33,-5px_-5px_10px_0_#D1DFEA4D_inset] 
                    transition-all  
                  `}
                >
                  <td className="px-4 py-3 text-gray-700 text-sm sm:text-base font-medium">
                    {row.feature}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm sm:text-base font-medium text-center">
                    {row.competitor}
                  </td>
                  <td className="px-4 py-3 text-red-500 text-sm sm:text-base text-center">
                    {row.payrollOnly}
                  </td>
                  <td className="px-4 py-3 text-green-500 text-sm sm:text-base text-center">
                    {row.waggex}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
